export default __webpack_public_path__ + "static/media/batch-client-employee.e29f0f99.png";